module.exports = __webpack_public_path__ + "media/img/frontend_application/vnfc-new-pay-logo-72e0be9232985792baddad8186f22b3d.svg";